/**
 * #1102 item 6 (owner, 2026-10-28): whether the keybook offers "Show as admin". Decided from the SERVER's answer,
 * never the role: offered when the keybook it returned holds a key or collection this person reads only through
 * their role's root grant (`hiddenWithoutAdminView`) — i.e. when the switch would change what the page shows. The
 * root grants are the tier; the server decides what each row is, as on the drive's Projects / PDApps pages. Never on
 * a personal keybook (nothing there is read through a role).
 */
export function offersKeybookAdminView(
  isOrg: boolean | undefined,
  entries: ReadonlyArray<{ hiddenWithoutAdminView?: boolean }>,
  collections: ReadonlyArray<{ hiddenWithoutAdminView?: boolean }>,
): boolean {
  return !!isOrg && (entries.some((e) => e.hiddenWithoutAdminView === true) || collections.some((c) => c.hiddenWithoutAdminView === true))
}
